import * as Category from 'types/Ingredient/Detail/Category';

export type Type = Category.Type[];

export function create(): Type {
	return [];
}
